/* eslint-disable @typescript-eslint/no-explicit-any */
import classes from './ccf-call-controls.module.scss';
import {
  Box,
  Paper,
  Grow,
  IconButton
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { CCfToggleIconButton } from '@nice-ccf/ui-controls';
import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit';

interface CallIcons{
  type : 'toggle' | 'action'; 
  icon : React.ReactNode;
  toggleIcon?: React.ReactNode;
  dispatcherAction: any;
  // dispatcherAction: ActionCreatorWithoutPayload<string> | ActionCreatorWithPayload<string>;
  className?: string;
}

/* eslint-disable-next-line */
export interface CcfCallControlsProps {
  icons: CallIcons[];
  animate?: boolean;
  className?: string;
}

/**
 * 
 * @param props - CcfCallControlsProps
 * @example <CcfCallControls />
 * @returns 
 */
export function CcfCallControls(props: CcfCallControlsProps) {
  const {
    icons,
    className,
    animate = true,
    ...rest
  } = props;

  const dispatch = useDispatch();

  /**
   * 
   * @param type - string
   * @param icon - React.ReactNode
   * @param dispatcherAction - ActionCreatorWithoutPayload 
   * @param className - string
   * @param toggleIcon - React.ReactNode
   * @example - renderIcon()
   * @returns 
   */
  const renderIcon = (
    type: 'toggle' | 'action',
    icon: React.ReactNode,
    dispatcherAction: ActionCreatorWithoutPayload<string>,
    className?: string,
    toggleIcon?: React.ReactNode
  ) => {
    switch (type) {
      case 'toggle':
        return <CCfToggleIconButton
          icon={icon}
          toggleIcon={toggleIcon}
          className={className}
          onClick={() => dispatch(dispatcherAction())}
        />;
      default:
        return <IconButton
          children={icon}
          className={className}
          onClick={() => dispatch(dispatcherAction())}
        />
    }
  };

  return (
    <Box
      borderRadius={4}
      mt={1}
      mb={0.5}
      p={0.5}
      bgcolor="background.default"
      color="text.secondary"
      className={classes.callControl}
      {...rest}
    >
      <Grow in={animate} timeout={500}>
        <Paper>
          {icons.map(({ type, icon, toggleIcon, className, dispatcherAction }: any) =>
            renderIcon(type, icon, dispatcherAction, className, toggleIcon)
          )}
        </Paper>
      </Grow>
    </Box>
  );
}

export default CcfCallControls;
